'use strict'

import _ from 'lodash'
import moment from 'moment'
import clienti from '@/services/clientiService.js'
import fidelity from '@/services/fidelityService.js'
import configurazioni from '@/services/configurazioniService.js'
import movimenti from '@/services/movimentiService.js'
import magazzino from '@/services/magazzinoService.js'
import modbus from '@/services/custom/modbus.js'

const registraTornello = async function(payload, impostazioni) {
  let tipoCausale = 'accessi_entrata'
  const tessera = payload.code
  // entrata, uscita
  // da fidelity  (per barcode) --> cliente.codice
  const card = await fidelity.getFidelity(tessera)
  // TODO: verificare successivo, sarebbe più veloce. Attualmente però non viene riportato numero tessera !!
  // const cliente = await clienti.getCardFromBarcode(tessera)
  let messaggioErrore = ''

  if (!card.abilita) {
    messaggioErrore = 'Tessera non abilitata'
  }
  if (card.dallaData && moment().isBefore(card.dallaData)) {
    messaggioErrore = 'Tessera non ancora attiva'
  }
  if (card.allaData && moment().isAfter(card.allaData)) {
    messaggioErrore = 'Tessera scaduta'
  }

  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const cliente = await clienti.getCliente(card.cliente.codice)
  if (_.get(impostazioni, 'postazioni.entrata', '') === _.get(impostazioni, 'postazioni.uscita', '')) {
    // Stessa postazione. Registro uscita se c'è precedente entrata e deltaTempo minore di impostazione
    const oreDeltaTempoUscita = _.get(impostazioni, 'postazioni.oreDeltaTempoUscita', 8)
    const elencoEntrate = await movimenti.getMovimentiPerRiferimento('accessi_entrata', tessera)
    const elencoUscite = await movimenti.getMovimentiPerRiferimento('accessi_uscita', tessera)
    const elencoAccessi = _.sortBy(elencoEntrate.concat(elencoUscite), ['data'])
    if (elencoAccessi && elencoAccessi.length > 0) {
      const ultimaRegistrazione = elencoAccessi[elencoAccessi.length - 1]
      if (ultimaRegistrazione.causale === 'accessi_entrata' && moment().diff(moment(ultimaRegistrazione.data), 'hours') < oreDeltaTempoUscita) {
        tipoCausale = 'accessi_uscita'
      }
    }
  } else {
    const postazione = configurazioni.getPostazione()
    if (postazione === _.get(impostazioni, 'postazioni.entrata', '')) {
      tipoCausale = 'accessi_entrata'
    } else if (postazione === _.get(impostazioni, 'postazioni.uscita', '')) {
      tipoCausale = 'accessi_uscita'
    } else {
      console.log('ATTENZIONE !! Postazione non configurata')
      tipoCausale = ''
    }
  }

  const limiteAccessi = impostazioni.limiteAccessi
  if (limiteAccessi && limiteAccessi.abilita && limiteAccessi.tipoCausale === tipoCausale && card.accesso) {
    if ((parseInt(card.accesso.numeroIngressiContati) || 0) >= parseInt(card.accesso.numeroIngressi)) {
      messaggioErrore = limiteAccessi.messaggioErrore || 'Numero ingressi esaurito'
    } else {
      card.accesso.numeroIngressiContati = (parseInt(card.accesso.numeroIngressiContati) || 0) + 1
      await fidelity.aggiornaAccesso(card)
    }
  }

  if (messaggioErrore) {
    return {
      card,
      messaggioErrore
    }
  }

  if (impostazioni.modbus) {
    let comando = null
    if (_.get(impostazioni, 'modbus.bidirezionale', '')) {
      comando = _.get(impostazioni, 'modbus.bidirezionale')
    } else {
      comando = tipoCausale === 'accessi_entrata' ? _.get(impostazioni, 'modbus.entrata') : _.get(impostazioni, 'modbus.uscita')
    }
    modbus.pulseCoil(comando.ip, comando.address, comando.timeout)
  }

  const causale = causali.find(el => el.codice === tipoCausale)
  const movimento = {
    magazzino: _.get(impostazioni, 'registrazione.magazzino', 'mag01'),
    tipo: causale.tipo,
    causale: causale.codice,
    data: new Date(),
    riferimento: {
      id: tessera,
      tipo: tipoCausale
    },
    mostraCliente: true,
    mostraFornitore: false,
    tipoPrezzo: null,
    quantita: 1,
    prodotto: {
      codice: _.get(impostazioni, 'registrazione.prodotto', 'accesso'),
      um: 'n'
    },
    anagrafica: {
      cliente: cliente
    }
  }
  console.log(movimento)

  await magazzino.creaMovimentiMultipli([movimento])
  return {
    card,
    utilizzo: tipoCausale === 'accessi_entrata' ? 'Entrata' : 'Uscita'
  }
}

const registraSbloccoPorta = async function(payload, impostazioni) {
  const tipoCausale = 'accessi_sblocco'
  const tessera = payload.code
  const causali = await configurazioni.getConfigurazione('magazzino_causali', 'causali')
  const card = await fidelity.getFidelity(tessera)
  // TODO: verificare successivo, sarebbe più veloce. Attualmente però non viene riportato numero tessera !!
  // const cliente = await clienti.getCardFromBarcode(tessera)
  const cliente = await clienti.getCliente(card.cliente.codice)

  let messaggioErrore = ''

  if (!card.abilita) {
    messaggioErrore = 'Tessera non abilitata'
  }
  if (card.dallaData && moment().isBefore(card.dallaData)) {
    messaggioErrore = 'Tessera non ancora attiva'
  }
  if (card.allaData && moment().isAfter(card.allaData)) {
    messaggioErrore = 'Tessera scaduta'
  }

  const limiteAccessi = impostazioni.limiteAccessi
  if (limiteAccessi && limiteAccessi.abilita && limiteAccessi.tipoCausale === tipoCausale && card.accesso) {
    if ((card.accesso.numeroIngressiContati || 0) >= card.accesso.numeroIngressi) {
      messaggioErrore = limiteAccessi.messaggioErrore || 'Numero ingressi esaurito'
    } else {
      card.accesso.numeroIngressiContati = (card.accesso.numeroIngressiContati || 0) + 1
      await fidelity.aggiornaAccesso(tessera)
    }
  }

  if (messaggioErrore) {
    return {
      card,
      messaggioErrore
    }
  }

  if (impostazioni.modbus) {
    if (_.get(impostazioni, 'modbus.sblocco', '')) {
      const comando = _.get(impostazioni, 'modbus.sblocco')
      modbus.pulseCoil(comando.ip, comando.address, comando.timeout)
    }
  }

  const causale = causali.find(el => el.codice === tipoCausale)
  const movimento = {
    magazzino: _.get(impostazioni, 'registrazione.magazzino', 'mag01'),
    tipo: causale.tipo,
    causale: causale.codice,
    data: new Date(),
    riferimento: {
      id: tessera,
      tipo: tipoCausale
    },
    mostraCliente: true,
    mostraFornitore: false,
    tipoPrezzo: null,
    quantita: 1,
    prodotto: {
      codice: _.get(impostazioni, 'registrazione.prodotto', 'accesso'),
      um: 'n'
    },
    anagrafica: {
      cliente: cliente
    }
  }
  console.log(movimento)

  await magazzino.creaMovimentiMultipli([movimento])
  return {
    card,
    utilizzo: 'Sblocco porta'
  }
}

export default {
  registraTornello,
  registraSbloccoPorta
}
